import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { VisitorSignInStepper } from '../../visitor/signIn';
import { v4 as uuidv4 } from 'uuid';

export const ReceptionSignIn: React.FC = () => {
  const badgeNumber = useRef(uuidv4());
  const { search } = useLocation();

  return (
    <VisitorSignInStepper
      receptionMode
      returnUrl={`/reception${search}`}
      badgeNumber={badgeNumber.current}
    />
  );
};
